export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  image: string;
  date: string;
  readCount: number;
  tags: string[];
  content: string;
  author: string;
}

export const categories = [
  { name: '网红塌房', slug: 'wanghong-tafang', description: '追踪网红圈最新塌房事件，揭秘网红背后的真实面目。' },
  { name: '娱乐圈爆料', slug: 'yule-baoliao', description: '娱乐圈最新猛料，明星八卦一手掌握。' },
  { name: '黑料实锤', slug: 'heiliao-shichui', description: '实锤黑料大合集，真相只有一个。' },
  { name: '吃瓜前线', slug: 'chigua-qianxian', description: '第一手吃瓜资讯，最快最新的爆料汇总。' },
  { name: '热门话题', slug: 'remen-huati', description: '全网最热吃瓜话题，引爆你的吃瓜魂。' },
  { name: '深度扒皮', slug: 'shendu-bapi', description: '深度挖掘事件真相，全面还原来龙去脉。' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某千万粉丝网红深夜直播翻车，口误爆出惊天大瓜',
    excerpt: '近日，某拥有千万粉丝的头部网红在深夜直播中不慎说漏嘴，爆出了与另一位知名主播之间的恩怨内幕，引发全网热议。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20dramatic%20illustration%20of%20a%20livestreaming%20influencer%20in%20distress%20with%20glitch%20effects%2C%20dark%20moody%20background%20with%20neon%20pink%20and%20lime%20green%20accents%2C%20digital%20art%20style%2C%20social%20media%20drama%20concept%2C%20modern%20editorial%20illustration%20with%20strong%20composition%2C%20trending%20news%20vibe%2C%20chaotic%20energy%2C%20warm%20lighting%20contrast&width=800&height=500&seq=article-1-hero&orientation=landscape',
    date: '2026-07-06',
    readCount: 128300,
    tags: ['网红', '直播', '塌房', '爆料'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-2',
    title: '娱乐圈又爆大瓜！某当红女星被拍到深夜私会神秘男子',
    excerpt: '狗仔队拍到某当红一线女星深夜与一名神秘男子共同进出某高档小区，两人举止亲密，疑似恋情曝光。',
    category: '娱乐圈爆料',
    categorySlug: 'yule-baoliao',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20noir%20illustration%20of%20a%20celebrity%20couple%20walking%20at%20night%20with%20paparazzi%20camera%20flashes%2C%20dark%20atmospheric%20street%20scene%2C%20glamorous%20and%20mysterious%20vibe%2C%20red%20carpet%20drama%20concept%2C%20editorial%20digital%20art%2C%20warm%20golden%20street%20lights%20on%20dark%20background%2C%20luxury%20aesthetic%2C%20celebrity%20gossip%20theme&width=800&height=500&seq=article-2-hero&orientation=landscape',
    date: '2026-07-05',
    readCount: 96500,
    tags: ['娱乐圈', '女星', '恋情', '狗仔'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-3',
    title: '某品牌带货大V涉嫌虚假宣传，粉丝集体维权',
    excerpt: '知名带货主播被爆料在直播间虚假宣传产品功效，大量购买粉丝发现上当受骗后联合发起维权行动。',
    category: '黑料实锤',
    categorySlug: 'heiliao-shichui',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20digital%20illustration%20of%20a%20livestream%20shopping%20scene%20with%20warning%20symbols%2C%20consumer%20rights%20concept%2C%20dramatic%20red%20and%20gray%20color%20palette%2C%20ecommerce%20drama%20theme%2C%20modern%20editorial%20style%2C%20protest%20vibes%2C%20clean%20composition%20with%20bold%20graphic%20elements%2C%20social%20commentary%20illustration&width=800&height=500&seq=article-3-hero&orientation=landscape',
    date: '2026-07-05',
    readCount: 87300,
    tags: ['带货', '维权', '虚假宣传', '实锤'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-4',
    title: '吃瓜速递：本周最劲爆八卦合集，你错过了几个？',
    excerpt: '本周娱乐圈和网红圈波澜不断，从恋情曝光到人设崩塌，我们为你整理了一份本周最全吃瓜指南。',
    category: '吃瓜前线',
    categorySlug: 'chigua-qianxian',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20stylized%20collage%20illustration%20of%20breaking%20news%20and%20gossip%20headlines%2C%20social%20media%20trending%20concept%2C%20colorful%20pop%20art%20style%2C%20magazine%20cover%20layout%20vibe%2C%20lime%20green%20and%20coral%20accents%20on%20dark%20background%2C%20weekly%20roundup%20theme%2C%20energetic%20and%20engaging%20visual%2C%20news%20aggregation%20concept&width=800&height=500&seq=article-4-hero&orientation=landscape',
    date: '2026-07-04',
    readCount: 156200,
    tags: ['合集', '八卦', '周报', '热点'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-5',
    title: '热搜第一！某选秀出道人设崩塌，前工作人员曝光内幕',
    excerpt: '一位自称是某选秀节目前工作人员的人士在社交平台发文，详细揭露了某位当红偶像的真实面目。',
    category: '深度扒皮',
    categorySlug: 'shendu-bapi',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20talent%20show%20stage%20with%20a%20spotlight%20crashing%20down%2C%20symbolic%20of%20idol%20fall%20from%20grace%2C%20dark%20dramatic%20theater%20scene%2C%20exposure%20concept%2C%20modern%20editorial%20digital%20art%2C%20warm%20spotlight%20beam%20on%20dark%20stage%2C%20revealing%20secrets%20theme%2C%20backstage%20drama&width=800&height=500&seq=article-5-hero&orientation=landscape',
    date: '2026-07-04',
    readCount: 112800,
    tags: ['选秀', '偶像', '人设崩塌', '内幕'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-6',
    title: '热门话题：为什么2026年的网红塌房速度越来越快？',
    excerpt: '从爆红到翻车，当代网红的生命周期似乎越来越短。我们分析了近期的多起塌房事件，探讨背后的深层原因。',
    category: '热门话题',
    categorySlug: 'remen-huati',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20illustration%20of%20dominoes%20falling%20representing%20influencer%20scandals%2C%20one%20after%20another%2C%20stylized%20minimalist%20design%2C%20warm%20coral%20and%20dark%20contrast%2C%20social%20media%20trend%20analysis%20concept%2C%20editorial%20digital%20art%2C%20clean%20modern%20composition%2C%20thought-provoking%20visual%20metaphor&width=800&height=500&seq=article-6-hero&orientation=landscape',
    date: '2026-07-03',
    readCount: 78100,
    tags: ['网红', '塌房', '分析', '趋势'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-7',
    title: '独家爆料：某知名MCN机构内部聊天记录流出',
    excerpt: '一份据称来自某头部MCN机构的内部聊天记录在网络疯传，内容涉及多个知名网红的幕后操作手法。',
    category: '黑料实锤',
    categorySlug: 'heiliao-shichui',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20leaked%20documents%20and%20chat%20messages%20floating%20in%20digital%20space%2C%20corporate%20secrets%20exposed%20concept%2C%20dark%20background%20with%20glowing%20text%20elements%2C%20hacker%20aesthetic%2C%20MCN%20agency%20drama%20theme%2C%20modern%20editorial%20design%2C%20investigative%20journalism%20vibe%2C%20suspenseful%20atmosphere&width=800&height=500&seq=article-7-hero&orientation=landscape',
    date: '2026-07-03',
    readCount: 143600,
    tags: ['MCN', '聊天记录', '内幕', '独家'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-8',
    title: '某综艺节目录制现场爆发冲突，多位艺人当场离场',
    excerpt: '据现场观众透露，某热门综艺在最新一期录制过程中，因节目组恶意剪辑问题，多位参与录制的艺人当场表示不满并离开。',
    category: '娱乐圈爆料',
    categorySlug: 'yule-baoliao',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20TV%20show%20set%20in%20chaos%2C%20people%20walking%20out%2C%20dramatic%20studio%20lighting%2C%20conflict%20and%20tension%20concept%2C%20variety%20show%20drama%20theme%2C%20modern%20editorial%20digital%20art%2C%20warm%20studio%20lights%20contrasting%20dark%20shadows%2C%20behind%20the%20scenes%20scandal&width=800&height=500&seq=article-8-hero&orientation=landscape',
    date: '2026-07-02',
    readCount: 104900,
    tags: ['综艺', '冲突', '录制', '离场'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-9',
    title: '吃瓜科普：如何辨别真假爆料？老吃瓜人的经验分享',
    excerpt: '在海量的网络爆料中，如何分辨哪些是有据可查的真瓜，哪些是凭空捏造的假瓜？资深吃瓜群众来支招。',
    category: '吃瓜前线',
    categorySlug: 'chigua-qianxian',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20magnifying%20glass%20over%20social%20media%20posts%2C%20fact%20checking%20concept%2C%20digital%20literacy%20theme%2C%20warm%20analytical%20vibe%2C%20clean%20modern%20editorial%20style%2C%20true%20vs%20false%20visual%20metaphor%2C%20educational%20yet%20engaging%20design%2C%20investigative%20approach&width=800&height=500&seq=article-9-hero&orientation=landscape',
    date: '2026-07-02',
    readCount: 65200,
    tags: ['科普', '辨别', '真假', '经验'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-10',
    title: '年度最令人震惊的十大网红塌房事件回顾',
    excerpt: '回顾过去一年中那些让人目瞪口呆的网红塌房名场面，每一件都堪称教科书级别的翻车案例。',
    category: '深度扒皮',
    categorySlug: 'shendu-bapi',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20retrospective%20illustration%20with%20top%2010%20countdown%20design%2C%20collection%20of%20dramatic%20moments%2C%20award%20show%20style%20layout%20concept%2C%20dark%20glamorous%20background%2C%20gold%20and%20coral%20accents%2C%20year%20in%20review%20theme%2C%20editorial%20digital%20art%2C%20celebration%20of%20scandals%20vibe&width=800&height=500&seq=article-10-hero&orientation=landscape',
    date: '2026-07-01',
    readCount: 198400,
    tags: ['年度', '回顾', '盘点', 'TOP10'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-11',
    title: '某美食博主被曝食品卫生问题，后厨画面触目惊心',
    excerpt: '有网友暗访某知名美食博主的工作室后厨，拍到了大量令人震惊的卫生问题画面，引发食安担忧。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20messy%20kitchen%20with%20warning%20signs%2C%20food%20safety%20scandal%20concept%2C%20dark%20dirty%20contrast%20with%20clean%20food%20blog%20aesthetic%2C%20exposure%20theme%2C%20modern%20editorial%20digital%20art%2C%20shocking%20reveal%20composition%2C%20health%20risk%20visual&width=800&height=500&seq=article-11-hero&orientation=landscape',
    date: '2026-07-01',
    readCount: 91600,
    tags: ['美食博主', '卫生', '曝光', '食品安全'],
    author: '吃瓜小编',
    content: '',
  },
  {
    id: 'article-12',
    title: '热议：某知名情侣网红突然删光合照，疑似分手',
    excerpt: '拥有千万CP粉的知名情侣网红组合突然清空了所有社交平台上的合照，粉丝纷纷猜测两人已经分手。',
    category: '热门话题',
    categorySlug: 'remen-huati',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20broken%20heart%20made%20of%20deleted%20social%20media%20photos%2C%20relationship%20drama%20concept%2C%20warm%20melancholic%20color%20palette%2C%20couple%20breakup%20theme%2C%20modern%20editorial%20digital%20art%2C%20emptiness%20and%20loss%20visual%2C%20social%20media%20cleanup%20concept&width=800&height=500&seq=article-12-hero&orientation=landscape',
    date: '2026-06-30',
    readCount: 135700,
    tags: ['情侣', '分手', '删照', '猜测'],
    author: '吃瓜小编',
    content: '',
  },
];

export const featuredArticles = [articles[0], articles[4], articles[7]];
export const trendingArticles = [articles[1], articles[3], articles[5], articles[2], articles[10], articles[11]];